import type { CreditBoosterQuest } from '@/containers/SubscriptionFormPageNew/Components/CreditBooster/useCreditBoosterContent'
import { TooltipText } from '@/containers/SubscriptionFormPageNew/Components/CreditBooster/SaleQuest/styled-components'

interface SaleQuestTooltipProps {
  quest: CreditBoosterQuest
  addLabel: string
}

const SaleQuestTooltip = ({ quest, addLabel }: SaleQuestTooltipProps) => (
  <>
    <TooltipText>{quest.description}</TooltipText>
    <TooltipText hidden={quest.sold}>{addLabel} →</TooltipText>
  </>
)

export default SaleQuestTooltip
